import { useEffect, useMemo, useState } from "react";

import { useToast } from "../../../Hooks/ToasContext";

import { useForm } from "react-hook-form";
import { IStockManagerListEntity } from "../../../Services/api/stocks/stocks.interface";
import { ListMangerStocksUseCase } from "../../../Usecase/Stocks/list-manager-stocks-usecase";
import { ListProductUseCase } from "../../../Usecase/Products/list-product-usecase";
import { IProductEntity } from "../../../Services/api/products/products.interface";
import { ListStocksUseCase } from "../../../Usecase/Stocks/list-stocks-usecase";


interface IUseListStocksProps {
  listStocksUseCase: ListStocksUseCase
}
export function useListStocks({ listStocksUseCase }: IUseListStocksProps){
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [data, setData] = useState<any[]>([])
    const [totalRegisters, setTotalRegisters] = useState(0)
    const [showFiltersModal, setShowFiltersModal] = useState(false)

    const { control } = useForm()

    const { showToast } =  useToast()

    // const listProdcuts = async ({ page: currentPage, searchBy}: { page : number; searchBy?: string }) => {
        
    //     try {
    //       setLoading(true)
          
    //       const listResult = await listProductUseCase.handle({ page: currentPage, searchBy });

    //       if (listResult.isFailure) {
       
    //         showToast(String(listResult?.error?.error), 'error');
    //         return;
    //       }

    //      const list = listResult.getValue()
      
    //      if(list){
    //         setData(list.data)
    //         setTotalRegisters(list.total)
    //      }

         

    //      setPage(currentPage)
    //     } catch (error) {
    //       console.log("error listStocks function: ", error)
    //     } finally {
    //       setLoading(false);
    //     }
    //   };

    const listStocks = async ({ page: currentPage, searchBy}: { page : number; searchBy?: string }) => {
      
      try {
        setLoading(true)
        
        const listResult = await listStocksUseCase.handle({ page: currentPage, search: searchBy });

        if (listResult.isFailure) {
      
          showToast(String(listResult?.error?.error), 'error');
          return;
        }

        const list = listResult.getValue()
    
        if(list){
          setData([...list?.data])
          setTotalRegisters(list.total)
        }

        

        setPage(currentPage)
      } catch (error) {
        console.log("error listStocks function: ", error)
      } finally {
        setLoading(false);
      }
    };

    

    const list = useMemo(() => {
        const rows = data?.map(product => {

            return {
                id: product?.productId,
                internalName: product?.productInternalName,
                name: product?.productName,
                allocatedStockQuantity: product?.allocatedStockQuantity,
                workInProgressQuantity: product?.workInProgressQuantity,
                finishedGoodsQuantity: product?.finishedGoodsQuantity,
                photo: product?.productImages?.[0]?.link || 'https://acdn.mitiendanube.com/stores/002/907/105/themes/common/logo-1336738559-1706047471-a90c2b04f7208c4f190adf866d8df0b51706047472-320-0.webp'
            }
        })

        return rows
    }, [data])

    useEffect(() => {
      listStocks({ page: 1})
  }, [])



      

    return {
        loading,
        list,
        data,
        totalRegisters,
        control,
        showFiltersModal,
        setShowFiltersModal,
        listStocks,
        
    }
}